export const styles = {
    paddingX: "px-10 md:px-20 lg:px-40 2xl:px-64",
    underlineTransition: "relative hover:before:w-full before:w-0 before:h-1 before:bg-black before:absolute before:left-0 before:-bottom-2 before:transition-all before:duration-300"
}